import script from "./subnet-installed-uninstalled-chart.vue?vue&type=script&lang=ts&setup=true"
export * from "./subnet-installed-uninstalled-chart.vue?vue&type=script&lang=ts&setup=true"

import "./subnet-installed-uninstalled-chart.vue?vue&type=style&index=0&id=17a62aa4&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17a62aa4"]])

export default __exports__